// DO NOT EDIT this file was generated with scripts/IntrinsicElements
import * as React from "react";

export interface FuroVerticalScroller extends React.HTMLAttributes<HTMLElement> {
  // no events defined.
  // properties
  // attributes
  // no attributes defined.
}

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      /**
       * `furo-vertical-scroller`
       *
       * ```html
       * <furo-vertical-scroller>
       * <your-content></your-content>
       * </furo-vertical-scroller>
       * ```
       */
      "furo-vertical-scroller": FuroVerticalScroller;
    }
  }
}
